const rest = "rest";
const rest_client = `${rest}/client`;

const Urls = {
	rest,
	LOGIN: 'login',
	CSRF_VALID: `${rest}/security/csrf/valid`,
	CUSTOMER_BY_ID: `${rest_client}/customer/{customerId}`,
	PURCHASED_SERVICES: `${rest_client}/customer/{customerId}/purchasedservice`,
	SEND_OTP_TO_EMAIL: `${rest}/otp/send/email`,
	SEND_OTP_TO_PHONE: `${rest}/otp/send/phone`,
	VALIDATE_OTP: `${rest}/otp/validate`,
	CREATE_USER: `${rest_client}/user`,
	EMAIL_EXISTS: `${rest_client}/user/email/exists`,
	PHONE_EXISTS: `${rest_client}/user/phone/exists`
};

export default Urls;